;(function () {
  'use strict'
  angular
    .module('contrast.preferences')
    .factory(
      'preferencesApiConfig',
      function preferencesApiConfigFactory($http, TS_BASE_URL) {
        'ngInject'

        return {
          getValue: getValue
        }

        function getValue(name) {
          return $http.get(TS_BASE_URL + '/teamserver/preference', {
            params: {
              name: name
            }
          })
        }
      }
    )
})()
